"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { api } from "@/lib/api";
import { useLearnerId } from "@/components/LearnerProvider";
import { Button } from "@/components/ui/button";
import { readBrowserState } from "@/lib/learning/browser-state";
type Change = { id: number; message: string };
export default function AssessmentUndo() {
  const user = useLearnerId(),
    router = useRouter();
  const [change, setChange] = useState<Change | null>(null),
    [busy, setBusy] = useState(false),
    [error, setError] = useState("");
  const key = user ? `english:assessment-undo:${user}` : "";
  useEffect(() => {
    const refresh = () => setChange(key ? readBrowserState(key) : null);
    refresh();
    window.addEventListener("learning-storage", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("learning-storage", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, [key]);
  function dismiss() {
    try {
      localStorage.removeItem(key);
    } catch {}
    setChange(null);
    setError("");
  }
  if (!change) return null;
  return (
    <aside
      aria-label="最近一次自评"
      className="mx-auto mt-3 flex max-w-5xl flex-wrap items-center justify-between gap-2 rounded-xl border border-primary/30 bg-primary/5 px-4 py-2"
    >
      <p role="status" className="text-sm">
        {change.message}
      </p>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            setError("");
            try {
              await api.undoAssessment(change.id);
              dismiss();
              window.dispatchEvent(new Event("mastery-changed"));
              router.refresh();
            } catch (e) {
              setError(e instanceof Error ? e.message : "未能撤销，请重试。");
            } finally {
              setBusy(false);
            }
          }}
        >
          撤销这次自评
        </Button>
        <Button variant="ghost" size="sm" disabled={busy} onClick={dismiss}>
          关闭提示
        </Button>
      </div>
      {error && (
        <p role="alert" className="w-full text-sm text-destructive">
          {error}
        </p>
      )}
    </aside>
  );
}
